import { motion } from "framer-motion";

// Section fade-up reveal on scroll
export const FadeUp = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Signature masked line-by-line reveal for headlines.
// lines: array of strings
export const MaskReveal = ({ lines, className = "", lineClassName = "", start = 0.15 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 0.9,
            delay: start + i * 0.12,
            ease: [0.16, 1, 0.3, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Section eyebrow label (mono, orange)
export const Eyebrow = ({ children, num }) => (
  <div className="flex items-center gap-3 font-mono-accent text-xs tracking-[0.25em] uppercase text-[#ff4500]">
    {num && <span className="text-[#52525b]">{num}</span>}
    <span>{children}</span>
  </div>
);
